/**
 * <s-gallery-arrows> — subtle previous/next arrows over the mobile product gallery
 * so shoppers see they can swipe for more photos. Hidden from md up by the caller.
 * Also used on the homepage brand-video row (templates/index.liquid), visible at all sizes.
 *
 * Target: the element's previous sibling with [data-product-gallery].
 * Commands (via commandfor/command on the inner buttons):
 *   --prev / --next — scroll the gallery one slide.
 * Each button is hidden when there is nothing further in that direction.
 */
class SGalleryArrows extends HTMLElement {
  #ac;
  #gallery;

  connectedCallback() {
    this.#gallery = this.parentElement?.querySelector('[data-product-gallery]');
    if (!this.#gallery) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.addEventListener('command', (event) => {
      if (event.command !== '--prev' && event.command !== '--next') return;
      const direction = event.command === '--next' ? 1 : -1;
      const rtl = getComputedStyle(this.#gallery).direction === 'rtl' ? -1 : 1;
      this.#gallery.scrollBy({ left: direction * rtl * this.#gallery.clientWidth, behavior: 'smooth' });
    }, { signal });
    this.#gallery.addEventListener('scroll', () => this.#sync(), { passive: true, signal });
    window.addEventListener('resize', () => this.#sync(), { passive: true, signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const g = this.#gallery;
    const max = g.scrollWidth - g.clientWidth;
    const pos = Math.abs(g.scrollLeft);
    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (prev) prev.hidden = pos <= 4;
    if (next) next.hidden = max <= 4 || pos >= max - 4;
  }
}

if (!customElements.get('s-gallery-arrows')) customElements.define('s-gallery-arrows', SGalleryArrows);
